<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kZTPma/tc-custom/9781429923729.jpg?1732051520030" alt="This image is the cover for the book Solitude of Self"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Solitude of Self
      </h1>
      <p class="bookDescription body article font2">
        <p>Elizabeth Cady Stanton—along with her comrade-in-arms, Susan B. Anthony—was one of the most important leaders of the movement to gain American women the vote. But, as Vivian Gornick argues in this passionate, vivid biographical essay, Stanton is also the greatest feminist thinker of the nineteenth century. Endowed with a philosophical cast of mind large enough to grasp the immensity that women's rights addressed, Stanton developed a devotion to equality uniquely American in character. Her writing and life make clear why feminism as a liberation movement has flourished here as nowhere else in the world.<br/><br/>Born in 1815 into a conservative family of privilege, Stanton was radicalized by her experience in the abolitionist movement. Attending the first international conference on slavery in London in 1840, she found herself amazed when the conference officials refused to seat her because of her sex. At that moment she realized that "In the eyes of the world I was not as I was in my own eyes, I was only a woman." At the same moment she saw what it meant for the American republic to have failed to deliver on its fundamental promise of equality for all. In her last public address, "The Solitude of Self," (delivered in 1892), she argued for women's political equality on the grounds that loneliness is the human condition, and that each citizen therefore needs the tools to fight alone for his or her interests.<br/><br/>Vivian Gornick first encountered "The Solitude of Self" thirty years ago. Of that moment Gornick writes, "I hardly knew who Stanton was, much less what this speech meant in her life, or in our history, but it I can still remember thinking with excitement and gratitude, as I read these words for the first time, eighty years after they were written, ‘We are  beginning where she left off.' "<br/><br/><i>The Solitude of Self</i> is a profound, distilled meditation on what makes American feminism American from one of the finest critics of our time.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vivian Gornick
      </h2>
      
      <p class="authorDescription body article"><P><B>Vivian Gornick</B>'s books include <I>Approaching Eye Level</I>, <I>The End of The Novel of Love</I>, and <I>The Situation and The Story</I>. She lives in New York City.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7ff31567